import React from 'react';
import './SharedBanner.scss';

const SharedBanner=(props)=>{
   return(
       <div className={`shared-banner ${props.styles}`} style={{ backgroundImage: `url(${props.backgroundImage})` }}>
           <h1 data-aos="zoom-in"
              data-aos-delay={100}>{props.title}</h1>
           <p data-aos="zoom-in"
              data-aos-delay={200}>{props.desc}</p>
             <div className="other">
                {props.other}
                {props.other2}
             </div>
       </div>
   )
};
export default SharedBanner ;
